import './new-product-popup.scss'
import { FC, useState } from "react"
import { Button } from "primereact/button"
import { InputText } from "primereact/inputtext"
import { addICProductsByShop, addOPProductsByShop, updateOPProductsByShop } from '../../productSlices'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from "yup";
import { SelectButton } from 'primereact/selectbutton'

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  type: Yup.string().required("Required"),
  packSize: Yup.number().required("Required")
});
interface NewProductPopupProps {
    isVisible:boolean;
    setVisible:Function;
    productToEdit: any;
    setProductToEdit:Function
}

interface ProductFromProps{
  name: string;
  type: number;
  packSize: number;
}
const items = [
  { name: 'Food', value: 1 },
  { name: 'Other', value: 2 }
];
const NewProductPopup : FC<NewProductPopupProps>= ({isVisible,setVisible, productToEdit, setProductToEdit}) => {
    const dispatch: Function = useDispatch();
    const [flavors, setFlavors] = useState([''])
    const selectedShop = useSelector((state: any) => state.user.selectedShop);
    const user = useSelector((state: any) => state.auth.user);
    const formik = useFormik<ProductFromProps>({
      initialValues:{
        name: productToEdit?.name ?? '',
        type: productToEdit ? Number(productToEdit.type) : 1,
        packSize: productToEdit?.pack_size ?? 0
      },
      enableReinitialize: true,
      validateOnMount: true,
      validationSchema,
      onSubmit: (newProduct) => {
        if(productToEdit){
          // The update endpoint expects the full OPProductUpdate payload;
          // keep the current quantities so only name/type/pack_size change.
          dispatch(updateOPProductsByShop(selectedShop, productToEdit.id, {
            id: productToEdit.id,
            name: newProduct.name,
            type: String(newProduct.type),
            pack_size: Number(newProduct.packSize),
            total_quantity: productToEdit.total_quantity,
            pack_count: productToEdit.pack_count
          }));
          setProductToEdit(null)
        }else{
          dispatch(addOPProductsByShop(selectedShop, {
            name: newProduct.name,
            type: newProduct.type,
            pack_size: Number(newProduct.packSize)
          }));
        }
        setVisible(false)
      },
    });
    const closePopup = () => {
      setVisible(false)
      setProductToEdit(null)
    }
    return (
      <>
      <div className="mask"></div>
      <div className="popup">
        <div className={`new-product-popup ${isVisible ? 'visible' : ''}`}>
          <div className="new-product-popup__header">
            <div className="new-product-popup__header__titles">
              <div className="new-product-popup__header__titles__title">{productToEdit ? 'Edit product' : 'New product'}</div>
              <div className="new-product-popup__header__titles__subtitle">{productToEdit ? 'Update this product' : 'Add new product to your stock'}</div>
            </div>
            <Button onClick={() => closePopup()} icon="pi pi-times" iconPos='right' className="new-product-popup__header__close-button" />
          </div>
          <div className="new-product-popup__content">
            <div className="new-product-popup__content__title">{productToEdit ? 'Product name' : 'New product'}</div>
            <InputText name="name" value={formik.values.name} onChange={formik.handleChange} placeholder='Waffles'/>
            <div className="new-product-popup__content__title">Select the type of yout product</div>
            <SelectButton value={formik.values.type} onChange={formik.handleChange} name="type" optionLabel="name" options={items} />
            <div className="new-product-popup__content__title">{'Pack size (number of units)'}</div>
            <InputText  name="packSize" value={formik.values.packSize.toString()} onChange={formik.handleChange} placeholder='Email address'/>
          </div>
          <div className="new-product-popup__footer">
            <Button onClick={() => closePopup()} iconPos='right' label={'Cancel'} className="new-product-popup__footer__cancel-button" />
            <Button onClick={() => formik.handleSubmit()} iconPos='right' label={'Confirm'} className="new-product-popup__footer__confirm-button" />
          </div>
        </div>
      </div>
      </>
    )
}

export default NewProductPopup